export default __webpack_public_path__ + "static/media/21t.289a9862.jpg";